import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { FormWidgetService } from '../form-widget.service';
import { StudentAssignmentDetailsModel } from 'common/models/page-models/Student Assignment/Student Assignment Details/student-assignment-details-data.model';
import { StudentAssignmentDetailsMetaModel } from 'common/models/page-models/Student Assignment/Student Assignment Details/student-assignment-details-meta.model';
import { StudentAssignmentDetailsDataService } from 'common/services/data-services/student/Student Assignment Details/student-assignment-details-data.service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';


@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentDetailsWidgetService extends FormWidgetService<StudentAssignmentDetailsModel> {
  constructor(
    protected ds: StudentAssignmentDetailsDataService,
    protected systemService: SystemService
  ) {
    super(ds);
  }

  getMetaModel(): MetaModel {
    const meta = new StudentAssignmentDetailsMetaModel().getMetaModel();
    return meta;
  }

  override prepareMetaModel(dataModel: DataModel, metaModel: StudentAssignmentDetailsMetaModel, routeData: WidgetModel): Promise<StudentAssignmentDetailsMetaModel> {
    // console.log(routeData)
    return new Promise<StudentAssignmentDetailsMetaModel>((resolve, reject) => {
      
        switch (routeData.transferData.transferData.type ) {
          case "complete":
          case "completed":
                metaModel.pageTitle = "Completed";
                break;
          case "incomplete":
          case "incompleted":
                metaModel.pageTitle = "Expired";
                break;
            case "todo":
                metaModel.pageTitle = "To Do";
                break;
          case "upcomingassignment":
          case "upcoming":
                metaModel.pageTitle = "To Do";
                break;        
            default:
                console.error("Unsupported type:", routeData.transferData.type);
                break;
        }
        resolve(metaModel);
    });
}

}
